<template lang="pug">
    app-plotly(nomeDiv="graficoProdutividade", :dados="graficoDados", :layout="layout")
</template>

<script>
import AppPlotly from '@/components/AppPlotly'

export default {
  components: {
    AppPlotly
  },

  props: {
    dadosLabels: {
      required: true
    }
  },

  methods: {
    getMediaProdutividade () {
      let media = this.mediaProdutividade.toFixed(2)
      media = media.replace('.', ',')
      return media
    }
  },

  data () {
    return {
      loading: true
    }
  },
  computed: {
    mediaProdutividade () {
      return this.dadosLabels.reduce((total, dado) => total + dado.produtividade, 0) / this.dadosLabels.length
    },

    graficoDados () {
      if (_.isEmpty(this.dadosLabels)) {  // eslint-disable-line
        return []
      }

      const graficoDados = [{
        x: [],
        y: [],
        text: [],
        textposition: 'auto',
        hoverinfo: 'text',
        marker: { color: [] },
        type: 'bar',
        width: this.dadosLabels.length > 2 ? 0.8 : 0.2
      },
      {
        x: [],
        y: [],
        text: `Média <br> ${this.getMediaProdutividade()}`,
        hoverinfo: 'text',
        mode: 'lines',
        line: {
          dash: 'dashdot',
          width: 3
        }
      }]

      for (let index = 0; index < this.dadosLabels.length; index++) {
        graficoDados[1].x.push(this.dadosLabels[index].nomeRazaoSocial.toUpperCase())

        graficoDados[0].x.push(this.dadosLabels[index].nomeRazaoSocial.toUpperCase())
        graficoDados[0].y.push(this.dadosLabels[index].produtividade)

        graficoDados[0].text.push(this.dadosLabels[index].produtividade)
        graficoDados[0].marker.color.push(this.dadosLabels[index].produtividade >= this.mediaProdutividade ? '#0571B0' : '#DB4325')

        graficoDados[1].y.push(this.mediaProdutividade)
      }

      return graficoDados
    },

    layout () {
      return {
        showlegend: false,
        xaxis: {
          title: '',
          tickfont: {
            size: 14,
            color: 'rgb(107, 107, 107)'
          },
          automargin: true
        },
        yaxis: {
          title: 'Produtividade',
          titlefont: {
            size: 16,
            color: 'rgb(107, 107, 107)'
          },
          tickfont: {
            size: 14,
            color: 'rgb(107, 107, 107)'
          }
        },
        legend: {
          x: 0,
          y: 1.0,
          bgcolor: 'rgba(255, 255, 255, 0)',
          bordercolor: 'rgba(255, 255, 255, 0)'
        },
        bargap: 0.15
      }
    },

    hasData () {
      return !_.isEmpty(this.dados)  // eslint-disable-line
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/produtividade/components/GraficoProdutividade.vue